/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ApiConfigurationModel = /** @class */ (function () {
            function ApiConfigurationModel(scope, growlService, processConfigurationId, processConfigurationService, systemLevelService, apiConfigurationService, queryConfigurationService, objectQueryService, deleteService, apiKeyService, externalApiService, baseUrl) {
                var _this = this;
                this.scope = scope;
                this.growlService = growlService;
                this.processConfigurationId = processConfigurationId;
                this.processConfigurationService = processConfigurationService;
                this.systemLevelService = systemLevelService;
                this.apiConfigurationService = apiConfigurationService;
                this.queryConfigurationService = queryConfigurationService;
                this.objectQueryService = objectQueryService;
                this.deleteService = deleteService;
                this.apiKeyService = apiKeyService;
                this.externalApiService = externalApiService;
                this.baseUrl = baseUrl;
                apiKeyService.getKeys().then(function (keys) {
                    _this.keys = keys;
                });
                this.baseUrl += "api/ExternalApi/";
                if (this.processConfigurationId) {
                    this.apiConfigurationService.getAllApiConfigurationsByProcessId(this.processConfigurationId)
                        .then(function (apiConfigurations) {
                        _this.apiConfigurations = apiConfigurations;
                    });
                    objectQueryService.getAllObjectQueriesForProcessConfiguration(this.processConfigurationId)
                        .then(function (objectQueries) {
                        _this.objectQueries = Enumerable.from(objectQueries).where(function (i) { return i.isExecutable; }).toArray();
                    });
                    this.processConfigurationService.getProcessConfigEagerLoadProcessType(this.processConfigurationId).then(function (processConfig) {
                        _this.processConfiguration = processConfig;
                    });
                }
                else {
                    this.systemLevelService.getSystemLevelApiConfigurations()
                        .then(function (systemLevel) {
                        _this.systemLevel = systemLevel;
                        _this.apiConfigurations = systemLevel.myApiConfigurations;
                    });
                    objectQueryService.getAllObjectQueriesForSystemLevel()
                        .then(function (objectQueries) {
                        _this.objectQueries = objectQueries;
                    });
                }
            }
            ApiConfigurationModel.prototype.addApiConfiguration = function () {
                var _this = this;
                var newApiConfiguration = this.apiConfigurationService.createApiConfiguration();
                if (this.processConfigurationId) {
                    newApiConfiguration.processConfiguration_id = this.processConfigurationId;
                }
                else {
                    newApiConfiguration.systemLevel_id = this.systemLevel.id;
                }
                newApiConfiguration.uniqueIdentifier = warsApp.services.UtilityService.generateGuidComb();
                this.apiConfigurationService.saveAllChanges(function () {
                    _this.apiConfiguration = newApiConfiguration;
                    _this.apiConfigurations.push(newApiConfiguration);
                    _this.showEdit = true;
                    _this.editingNew = true;
                });
            };
            ApiConfigurationModel.prototype.configureApiConfiguration = function (apiConfiguration) {
                this.apiConfiguration = apiConfiguration;
                this.showEdit = true;
                this.editingExisting = true;
                this.setExampleUrl();
            };
            ApiConfigurationModel.prototype.deleteApiConfiguration = function (apiConfiguration) {
                var _this = this;
                this.deleteService.deleteWithModalConfirmationIfNecessary("ApiConfiguration", apiConfiguration.id, "Successfully delete API Configuration", function () {
                    _this.apiConfigurations.remove(apiConfiguration);
                    _this.showEdit = false;
                }, "Could not delete API Configuration");
            };
            ApiConfigurationModel.prototype.selectApiQuery = function () {
                var _this = this;
                if (this.apiConfiguration.parameters.length > 0) {
                    this.apiConfiguration.parameters.forEach(function (parameter) {
                        parameter.entityAspect.setDeleted();
                    });
                }
                if (this.apiConfiguration.myObjectQuery &&
                    this.apiConfiguration.myObjectQuery.myInputObjectSchema &&
                    this.apiConfiguration.myObjectQuery.myInputObjectSchema.properties) {
                    this.apiConfiguration.myObjectQuery.myInputObjectSchema.properties
                        .forEach(function (property) {
                        var queryParameter = _this.queryConfigurationService.createNewQueryParameter();
                        queryParameter.name = property.name;
                        queryParameter.mySchemaProperty = property;
                        queryParameter.schemaProperty_id = property.id;
                        _this.apiConfiguration.parameters.push(queryParameter);
                    });
                }
                this.saveChanges();
            };
            ApiConfigurationModel.prototype.saveChanges = function () {
                this.setExampleUrl();
                this.apiConfigurationService.saveAllChanges();
            };
            ApiConfigurationModel.prototype.setExampleUrl = function () {
                if (this.apiConfiguration.name === null || this.apiConfiguration.name === undefined)
                    return;
                var apiName = this.apiConfiguration.name.replace(/\s+/g, '-').toLowerCase();
                var processConfigName = this.processConfigurationId
                    ? this.processConfiguration.myProcessType.name.replace(/\s+/g, '-').toLowerCase()
                    : '';
                if (this.apiConfiguration.apiType === 1 /* QueryGet */) {
                    if (this.processConfigurationId) {
                        var url = this.baseUrl + processConfigName + "/Query/" + apiName;
                        this.exampleUrl = this.addQueryStringParams(url, this.apiConfiguration.parameters);
                    }
                    else {
                        var url = this.baseUrl + "Query/" + apiName;
                        this.exampleUrl = this.addQueryStringParams(url, this.apiConfiguration.parameters);
                    }
                }
                else if (this.apiConfiguration.apiType === 10 /* PerProcessGet */) {
                    var paramerterPart = this.apiConfiguration.inputType ===
                        2 /* ProcessName */
                        ? "/[processName]"
                        : "/[processId]";
                    if (this.processConfigurationId) {
                        this.exampleUrl = this.baseUrl +
                            "GetAllProcessData/" +
                            processConfigName +
                            "/" +
                            apiName +
                            paramerterPart;
                    }
                    else {
                        this.exampleUrl = this.baseUrl + "GetAllProcessData/" + apiName + paramerterPart;
                    }
                }
            };
            ApiConfigurationModel.prototype.addQueryStringParams = function (url, parameters) {
                if (parameters && parameters.length > 0) {
                    url += "?";
                    for (var i = 0; i < parameters.length; i++) {
                        url += parameters[i].name.replace(/\s+/g, '-').toLowerCase() + "=[paramValue]&";
                    }
                    url = url.substring(0, url.length - 1);
                }
                return url;
            };
            ApiConfigurationModel.prototype.close = function () {
                this.showEdit = false;
            };
            return ApiConfigurationModel;
        }());
        models.ApiConfigurationModel = ApiConfigurationModel;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
